import React from 'react';

import LoginRequired from 'components/LoginRequired';

import {reverse} from 'utils/urls';
import {DEV_PLAYGROUND_URL} from 'config/urls';

import MainContent from './components/MainContent';

export const breadcrumbFactory = () => {
  return {
    parent: null,
    label: 'Dev Playground',
    url: reverse(DEV_PLAYGROUND_URL, {})
  };
};

const DevPlayground = () => {
  return (
    <div className="DevPlayground Allocations SideMainNavContainer">
      <main className="mainContent">
        <MainContent />
      </main>
    </div>
  );
};

export default LoginRequired(DevPlayground);
